import CartItem from '../component/cart/CartItem';
import { getCartOrLineItemGtagData } from './helpers';
import {
  CheckoutData, LineItem, PaymentData, PurchaseData,
} from './types';

export const logBeginCheckoutEvent = (items: CartItem[]): void => {
  const dataLayerViewEvent = {
    event: 'begin_checkout',
    ecommerce: {
      items: items.map((item, index) => ({
        ...getCartOrLineItemGtagData(item, CartJS.cart.items[index].quantity),
        index: index + 1,
      })),
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};

export const logAddShippingInfoEvent = (
  lineItems: LineItem[], checkoutData: CheckoutData,
): void => {
  const dataLayerEvent = {
    event: 'add_shipping_info',
    ecommerce: {
      currency: 'USD',
      value: checkoutData.total,
      coupon: checkoutData.discountCode || null,
      shipping_tier: checkoutData.shipping,
      items: lineItems.map((lineItem, index) => ({
        index: index + 1,
        ...getCartOrLineItemGtagData(lineItem, lineItem.data.quantity),
      })),
    },
  };

  // console.log('add shipping info event', dataLayerEvent);

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerEvent);
};

export const logAddPaymentInfoEvent = (
  lineItems: LineItem[], paymentData: PaymentData,
): void => {
  const dataLayerEvent = {
    event: 'add_payment_info',
    ecommerce: {
      currency: 'USD',
      value: paymentData.total,
      coupon: paymentData.discountCode || null,
      payment_type: paymentData.paymentType,
      items: lineItems.map((lineItem, index) => ({
        index: index + 1,
        ...getCartOrLineItemGtagData(lineItem, lineItem.data.quantity),
      })),
    },
  };

  // console.log('add payment info event', dataLayerEvent);

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerEvent);
};

export const logPurchaseEvent = (
  lineItems: LineItem[], purchaseData: PurchaseData,
): void => {
  const dataLayerEvent = {
    event: 'purchase',
    ecommerce: {
      currency: 'USD',
      value: purchaseData.total,
      coupon: purchaseData.discountCode || null,
      shipping: purchaseData.shippingCost,
      transaction_id: purchaseData.transactionId,
      tax: purchaseData.taxAmount,
      items: lineItems.map((lineItem, index) => ({
        index: index + 1,
        ...getCartOrLineItemGtagData(lineItem, lineItem.data.quantity),
      })),
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerEvent);
};
